import React from 'react';

import './Footer.scss';

function Footer() {
    return (
        <div className="footer">
            <span>&copy; Copyright {(new Date().getFullYear())} The Surplus Line Association of California. All Rights Reserved.</span>
        </div>
    );
}

export default Footer;